<template>
  <div class="registry-root">
    <div>
      <p class="emphasize">
        Your presence is the best gift you could give us, there is no need to get us anything else.
      </p>
      <nice-rule/>
      <div class="registry-after">
        <p>
          If you <em>really</em> want to give us something more, have a look at
          <a href="https://www.weddingshop.com/Buy/View/65553">
            our registry
          </a>
          or contact
          <a href="mailto:blah@blah.blah">
          Marietjie Vosloo
          </a>
          for bank details
        </p>
        <p>
          Or consider donating to <a href="//www.clientearth.org/why-clientearth/">ClientEarth</a> ;
          an environmental charity that seeks to bring about systemic change through legal avenues.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import NiceRule from '../components/NiceRule.vue'

  export default {
    name: 'Registry',
    components: { NiceRule },
  }
</script>

<style lang="scss" scoped>
  .registry-root {
    flex-grow: 1;
    min-height: 100%;
    max-width: 60em;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1.5em 2em;
    text-align: center;
    box-sizing: border-box;
  }

  .emphasize {
    font-size: 120%;
    font-weight: 500;
  }

  .registry-after {
    color: var(--text-color-unpop);
  }

  .donate {
    margin-top: 1em;
  }

  hr {
    border: 0;
    height: 1em;
    width: 20em;
    display: block;
    position: relative;

    &:before {
      display: inline-block;
      width: 100%;
      content: '';
      position: absolute;
      top: 0;
      height: 10px;
      background-image: linear-gradient(
          to right,
          rgba(0, 0, 0, 0),
          var(--text-color-unpop),
          rgba(0, 0, 0, 0)
      );
      margin: 2em auto;
    }

    &:after {
      content: '\002665';
      display: inline-block;
      position: relative;
      top: -1em;
      padding: 0 1em;
      background: white;
      color: var(--text-color-unpop);
      height: 1em;
    }

  }
</style>
